import EmployeeImagesGallery from 'components/EmployeeImagesGallery'
import { StyledLink } from 'components/StyledLink'
import React, { FC, useState } from 'react'
import { EmployeeApproveInfo } from 'search/context/types'
import { blue400 } from 'utils/theme/colors'
import { Cell, EmployeeName, LevelCell, NameBlock, PositionBlock, Row, Skills } from './styled'
import { CommentIcon } from 'images'
import { LevelIcon } from 'components/IconComponents/LevelIcon'
import { LEVEL_ABBREVIATIONS } from 'utils/enums/different'
import { IconSize } from 'utils/types/styling'
import { Checkbox, IconButton } from '@mui/material'
import GetCommentModal from './GetCommentModal'

interface Props {
    row: EmployeeApproveInfo
    selected: number[]
    setSelected: React.Dispatch<React.SetStateAction<number[]>>
}

const EmployeeApproveTableRow: FC<Props> = ({ row, selected, setSelected }) => {
    const [isCommentOpen, setIsCommentOpen] = useState(false)

    const handleOpenComment = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        setIsCommentOpen(true)
    }

    const handleClick = (requestId: number) => {
        selected=[...selected];
        const index=selected.findIndex(r => r===requestId);
        if ( index!==-1 )
            selected.splice(index,1);
        else
            selected.push(requestId);
        setSelected(selected);
    }

    const isSelected = (requestId: number) => selected.indexOf(requestId) !== -1

    const isItemSelected = isSelected(row.request_id)

    const labelId = `enhanced-table-checkbox-${row.user_id}`

    return (
        <Row
            key={row.name}
            role="checkbox"
            aria-checked={isItemSelected}
            tabIndex={-1}
            selected={isItemSelected}
            onClick={(event) => handleClick(row.request_id)}
        >
            <Cell padding="checkbox">
                <Checkbox checked={isItemSelected} inputProps={{ 'aria-labelledby': labelId }} />
            </Cell>
            <Cell>
                <StyledLink to={`/profile/${row.user_id}`} baseColor={blue400}>
                    <EmployeeName>
                        <EmployeeImagesGallery withoutBorder pic={row?.staffing_pic || row?.google_pic} />

                        <div>
                            <NameBlock>{row.name}</NameBlock>
                            <PositionBlock>{row.staffing_position}</PositionBlock>
                        </div>
                    </EmployeeName>
                </StyledLink>
            </Cell>
            <Cell>
                <Skills>{row.skill_name}</Skills>
            </Cell>

            <Cell>
                <LevelCell>
                    <LevelIcon
                        level={LEVEL_ABBREVIATIONS[row.new_level + 1]}
                        size={IconSize.Medium}
                        data-automation-id={`level-${LEVEL_ABBREVIATIONS[row.new_level + 1]}`}
                    />
                    {LEVEL_ABBREVIATIONS[row.new_level + 1]}
                </LevelCell>
            </Cell>
            <Cell>
                {
                  row.current_level &&
                <LevelCell>
                    <LevelIcon
                        level={LEVEL_ABBREVIATIONS[row.current_level + 1]}
                        size={IconSize.Medium}
                        data-automation-id={`level-${LEVEL_ABBREVIATIONS[row.current_level + 1]}`}
                    />
                    {LEVEL_ABBREVIATIONS[row.current_level + 1]}
                </LevelCell>
                }
            </Cell>

            <Cell align="center">
                {row.comment &&
                    <IconButton onClick={handleOpenComment}>
                        <CommentIcon />
                        <GetCommentModal
                            comment={row.comment}
                            isOpen={isCommentOpen}
                            onClose={() => setIsCommentOpen(false)}
                        />
                    </IconButton>
                }
            </Cell>
        </Row>
    )
}

export default EmployeeApproveTableRow
